import Calendar from '../../../collection/calendar';
import Collection from '../../../collection';
import View from '../../view';

import { nextMonth, beginMonth, 
    same, 
    tomorrow,
    datify,
    fmt,
    monthDuration } from '../../../utils/date';






export default View.extend( {

    serialize() {
        const { pattern } = this.options;
        // 1st of January, 2024 is a Monday - so,
        // it will be the first cell in calendar
        const dateSeed = datify( '2024-01-01 00:00:00' );

        return {
            calendars: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
                .map( monIndex => new Calendar( nextMonth( dateSeed, monIndex ) ) ),

            ['marker-color-scheme']: this.options['marker-color-scheme'],

            // как должен выглядеть реальный dates для calendar?
            // { date:X, ... }
            // X может быть как TimeStamp, так и строкой
            dates: new Collection( [
                ...Object.keys( pattern.v )
                    .map( ddmm => ({
                        date: datify( `${ddmm}.2024 00:00:00` ),
                        pickedUp: true,
                        toggleOff: pattern.remove[ddmm]
                    })),
                ...Object.keys( pattern.add )
                    .map( ddmm => ({ 
                        date: datify( `${ddmm}.2024 00:00:00` ), 
                        pickedUp: true
                    }))
            ] )
        }
    },

    [View.event( ':date:toggle' )](date) {
        return toggleDate.call( this, date ), 
            this.render();
    },

    [View.event( ':month:toggle' )](month) {
        return toggleMonth.call( this, month ), 
            this.render();
    }

} );






function toggleDate(date) {
    const { pattern, ...props } = this.model.clonePattern( this.options.pattern );
    pattern.value = [...this.options.pattern.value];
    pattern.v = { ...this.options.pattern.v };
    pattern.add = { ...this.options.pattern.add };
    pattern.remove = { ...this.options.pattern.remove };

    this.options.pattern = pattern;

    const finalize = () => this.model.set( props );

    if (pattern.add[fmt( date, 'DD.MM' )])
        return delete pattern.add[fmt( date, 'DD.MM' )], finalize();

    if (pattern.remove[fmt( date, 'DD.MM' )])
        return delete pattern.remove[fmt( date, 'DD.MM' )], finalize();

    if (pattern.v[fmt( date, 'DD.MM' )])
        return pattern.remove[fmt( date, 'DD.MM' )] = true, finalize();

    return pattern.add[fmt( date, 'DD.MM' )] = true, finalize();
}

function toggleMonth(month) {
    const firstOfMonth = beginMonth( month );

    let onCount = 0;
    const dates = [];
    for (let dt = firstOfMonth; same.month( dt, firstOfMonth ); dt = tomorrow( dt )) {
        dates.push( dt );
        if (isOn( this.options.pattern, dt )) onCount++;
    }

    const needTurnOff = onCount === monthDuration( firstOfMonth );
    for (let dt of dates)
        if (isOn( this.options.pattern, dt ) == needTurnOff)
            toggleDate.call( this, dt );
}

function isOn({ v, add, remove }, date) {
    if (add[fmt( date, 'DD.MM' )])
        return true;

    if (remove[fmt( date, 'DD.MM' )])
        return false;

    return !!v[fmt( date, 'DD.MM' )];
}




// WEBPACK FOOTER //
// ./src/js/view/module/schedule/pattern.yearly.js